import styled from 'styled-components'

export const TopNavWrapper = styled.div`
  position: relative;
  z-index: 10;
`

export const PartnerLogoWrapper = styled.div`
  height: 100%;
  margin-left: ${({ theme }) => theme.space.sm};
  position: absolute;
  left: 135px;
  top: -4px;
  display: flex;
  align-items: center;
  width: 120px;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    position: unset;
    left: unset;
    top: unset;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 160px;
  }

  img {
    height: 30px;

    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      height: 28px;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      height: 38px;
    }
  }
`
